export default axios => ({
    saveSystem(payload) {
        return axios.post(`/human-system-health/new-value`, payload)
    }
})
